import React, { useState, useEffect } from 'react';

import './ConditionEditor.css'
import classnames from 'classnames'

const INPUTABLE_VALUES = ['$', 'CHAT', '_', '{%', '%}']
// const INPUTABLE_VALUES = ['$', 'CHAT', '_', 'MODULE', 'UTIL']
// const INPUTABLE_VALUES =  ['$', 'CHAT', 'BOT', 'SYS', '_', 'MODULE', 'UTIL']
const REF_SYMBOL = '.'

const ConditionEditor = (props) => {
  const { condition, noDelBtn } = props
  const { onConfirm, onCancel, onDelete } = props
  const _condition = condition.condition
  console.log('condition :', condition);
  console.log('_condition :', _condition);
  const [ conditionText, setConditionText ] = useState(_condition === null ? '': _condition)
  const [ withDot, setWithDot ] = useState(false)
  console.log('conditionText :', conditionText);
  // Binding condition.condition (_condition) props to local state(conditionText) when changed
  useEffect(() => {
    setConditionText(_condition === null ? '': _condition)
  }, [_condition])

  const conditionEditorClassname = classnames('condition-editor', {
    'on': condition,
  })
  
  const onChangeConditionText = (e) => {
    const { target } = e
    const { value } = target

    setConditionText(value)
  }

  const onTagBoxClick = (value) => {
    setConditionText(conditionText + (withDot && value !== REF_SYMBOL ? REF_SYMBOL : '') + value)
  }

  return (
    <div className={conditionEditorClassname}>
      <div className='ez-input'>{
        INPUTABLE_VALUES.map((value, i) => (
          <InputTagBox key={i} value={value} onClick={onTagBoxClick} />
        ))
        }
        <div style={{textAlign: "left"}}>
          <input type='checkbox' id='with-dot' className='default-checkbox' onClick={(e) => {setWithDot(e.target.checked)}} checked={withDot} /> <label for='with-dot' onClick={(e) => {e.stopPropagation()}} ></label> 
          <span> <InputTagBox value={REF_SYMBOL} onClick={onTagBoxClick} /> 과 같이 입력 </span>
        </div>
      </div>
      {/* <div className='body-wrap'> */}
        <div className='condition-input'>
          <textarea value={conditionText} onChange={onChangeConditionText} placeholder='컨디션 입력' />
        </div>
        <div className='bottom'>
          {
            !noDelBtn && (
              <button className='del-btn' onClick={(e) => {onDelete()}}> 삭제 </button>
            ) 
          }
          <button className='confirm-btn' onClick={(e) => {onConfirm(conditionText)}}> 완료 </button>
          <button className='cancel-btn' onClick={onCancel}> 취소 </button>
        </div>
      {/* </div> */}
    </div>
  )
}

const InputTagBox = (props) => {
  const { value, onClick } = props
  return (
    <span className='tag-box' onClick={(e) => {onClick(value)}}>{value}</span>
  )
}

export default ConditionEditor